(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _video = require("./parts/video.js");
var _nav = require("./parts/nav.js");
var _skip = require("./parts/skip.js");
// import {getInsights} from "./parts/getinsights.js";
// import {getEvents} from "./parts/getevents.js";
window.addEventListener("load", function (event) {
  (0, _nav.nav)();
  (0, _skip.skip)();
  (0, _video.kiVideo)();
  // getInsights();
  // getEvents();
});

},{"./parts/nav.js":2,"./parts/skip.js":3,"./parts/video.js":4}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nav = nav;
function nav() {
  window.addEventListener("scroll", function () {
    var nav = this.document.getElementById("main-nav-container");
    var navLogo = this.document.querySelector("#main-nav-logo");
    var navIcon = this.document.getElementById("main-nav-btn");
    if (nav) {
      if (window.scrollY > 20) {
        nav.classList.add("scrolled");
        navIcon.classList.add("scrolled");
        navLogo.src = base44Data.base44_logo;
      } else {
        nav.classList.remove("scrolled");
        navIcon.classList.remove("scrolled");
        console.log(base44Data.reverse_logo);
        navLogo.src = base44Data.reverse_logo;
      }
    }
  });
}

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.skip = skip;
function skip() {
  var skip = document.getElementById("skip-btn");
  var content = document.getElementById("content");
  if (!content) {
    content = document.getElementById("carouselContainer");
  }
  skip.addEventListener("click", function (e) {
    if (content) {
      content.focus();
    }
  });
}

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kiVideo = kiVideo;
function kiVideo() {
  console.log("START KIVIDEO");
}

},{}]},{},[1]);
